/** /channel-partner/hub/customers — customers attributed through the CP code. */
import { createFileRoute } from '@tanstack/react-router';
import { ChannelPartnerHubCustomers } from '@/features/channel-partner/components/hub-customers';

export const Route = createFileRoute('/_protected/channel-partner/hub/customers')({
  component: ChannelPartnerHubCustomers,
});
